<script>
  // your script goes here
</script>

<div class="container">
  <div class="half-width">
    <video
      playsinline
      loop
      autoplay
      muted
      poster="https://images.uniformhero.com.au/assets/web/how-it-works-poster.jpg"
    >
      <source src="https://images.uniformhero.com.au/assets/web/how-it-works.mp4" type="video/mp4" />
      <source src="https://images.uniformhero.com.au/assets/web/how-it-works.webm" type="video/webm" />
    </video>
  </div>
  <div class="half-width how-to-steps">
    <h2>HOW IT WORKS</h2>
    <div class="steps-container">
      <div class="step-container">
        <div class="step">
          <div class="step-number">1</div>
          <div class="step-text">
            <h3>Choose your Product</h3>
            <p>
              We have a huge range of top quality products to choose from. Select the product you want to customise.
            </p>
          </div>
        </div>
      </div>
      <div class="step-container">
        <div class="step">
          <div class="step-number">2</div>
          <div class="step-text">
            <h3>Create Your Design</h3>
            <p>Use our online design tool to create your perfect design. Add names, logos and numbers.</p>
          </div>
        </div>
      </div>
      <div class="step-container">
        <div class="step">
          <div class="step-number">3</div>
          <div class="step-text">
            <h3>Checkout Online</h3>
            <p>Enter your quantity and sizing information and then checkout online.</p>
          </div>
        </div>
      </div>
      <div class="step-container">
        <div class="step">
          <div class="step-number">4</div>
          <div class="step-text">
            <h3>We Print & Ship Your Items</h3>
            <p>
              We check your artwork, print your items using the highest quality products and ship to you from our AU
              warehouse.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .container {
    display: flex;
    justify-content: center;
    padding: 5rem;
    flex-wrap: wrap;
  }

  .half-width {
    width: 50%;
  }

  video {
    width: 100%;
  }

  .how-to-steps {
    display: flex;
    flex-direction: column;
    padding-left: 8rem;
  }

  h2 {
    font-size: 3rem;
  }
  h3 {
    text-transform: uppercase;
  }

  p {
    color: #8c8c8c;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.7;
    padding: 0.5rem 0;
  }

  .steps-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .step-container {
    margin-top: 2rem;
    display: flex;
  }

  .step {
    display: flex;
    align-items: center;
  }

  .step-number {
    width: 4rem;
    height: 4rem;
    border-radius: 0.8rem;
    display: flex;
    background-color: #fe5900;
    color: white;
    justify-content: center;
    align-items: center;
    margin-right: 0.5rem;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }

  .step-text {
    margin-left: 2rem;
  }

  @media screen and (max-width: 800px) {
    .container {
      padding: 2rem;
    }
    .half-width {
      width: 100%;
    }

    .how-to-steps {
      padding-left: 0;
      margin-top: 2rem;
    }

    h2 {
      text-align: center;
    }
  }
</style>
